import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {Link, useHistory} from 'react-router-dom'
import { updateUserStart} from './../redux/User/user.actions'

import Button from './../components/forms/Button'
import FormInput from './../components/forms/FormInput'
import DashAuthWrapper from './../components/DashAuthWrapper'

import Geocode from "react-geocode";
Geocode.setApiKey(process.env.REACT_APP_GEOCODE_KEY);

const mapState = ({ user }) => ({
	currentUser: user.currentUser,
  	userErr: user.userErr
});

const EditAcctDetails = props => {

	const dispatch = useDispatch();
	const history = useHistory();
	const {  userErr, currentUser } = useSelector(mapState)
	const [EIN] = useState('NULL')
	const [contactName] = useState('NULL')
	const [contactEmail] = useState('NULL')

	const [displayName, setDisplayName] = useState(currentUser.displayName);
	const [address, setAddress] = useState(currentUser.address);
	const [address2, setAddress2] = useState(currentUser.address2);
	const [city, setCity] = useState(currentUser.city);
	const [state, setState] = useState(currentUser.state);
	const [zip, setZip] = useState(currentUser.zip);
	const [phone, setPhone] = useState(currentUser.phone);
	const [subscribed] = useState(currentUser.subscribed);
	let [fullAddress] = useState(currentUser.fullAddress);
	const [center, setCenter] = useState(0);

	useEffect(() => {
		if(Array.isArray(userErr) && userErr.length > 0){
			alert('Something went wrong')
		}
	}, [userErr]);

	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])


	const handleFormSubmit = event => {
		
		event.preventDefault();
		dispatch(updateUserStart({
			EIN,
			contactName,
			contactEmail,
			displayName,
			address,
			address2,
			city,
			state,
			zip,
			phone,
			subscribed,
			fullAddress,
			center
			
		}))
		history.push('/dashboard')
		alert('Update Successfull!')
		
	}

	fullAddress = `${address} ${address2} ${city}, ${state} ${zip}`

	useEffect(() => {
		Geocode.fromAddress(currentUser.fullAddress).then(
		response =>
			{ 
				setCenter(response.results[0].geometry.location);
				
			}
			
			// eslint-disable-next-line
		)}, []

		
	)

	const congfigAuthWrapper = {
		headline: 'Edit Account Details'
	}

	return (
		<DashAuthWrapper {...congfigAuthWrapper}>
		<form className="py-5 mx-auto" onSubmit={handleFormSubmit}>

			<div className="form-group text-left">
				<label htmlFor="displayName">Full Name</label>
				<FormInput 
					type="text" name="displayName" value={displayName} handleChange={e => setDisplayName(e.target.value)} className="form-control" required
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="address">Address</label>
				<FormInput 
					type="text" name="address" value={address} handleChange={e => setAddress(e.target.value)} className="form-control" required
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="address2">Address2</label>
				<FormInput 
					type="text" name="address2" value={address2} handleChange={e => setAddress2(e.target.value)} className="form-control" 
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="city">City</label>
				<FormInput 
					type="text" name="city" value={city} handleChange={e => setCity(e.target.value)} className="form-control" required
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="state">State</label>
				<FormInput 
					type="text" name="state" value={state} handleChange={e => setState(e.target.value)} className="form-control" required
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="zip">Zip Code</label>
				<FormInput 
					type="number" name="zip" value={zip} handleChange={e => setZip(e.target.value)} className="form-control" required
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="phone">Phone</label>
				<FormInput 
					type="number" name="phone" value={phone} handleChange={e => setPhone(e.target.value)} className="form-control" required
				/>
			</div>
			<div>
				<Button type="submit">
					EDIT
				</Button>
				<Link to="/dashboard">
					<Button className="btn cancel mx-3">
						CANCEL
					</Button>
				</Link>
			</div>	
			<div className="mt-3">
				<Link to="/recovery" className="resetLink">
					Reset Password
				</Link>
			</div>
			
		</form>
	</DashAuthWrapper>
	)
}

export default EditAcctDetails;
